import React from 'react';
import { useTranslation } from 'react-i18next';
import { Server, CheckCircle, XCircle, AlertTriangle } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

const TerminalStatsCards = ({ stats }) => {
  const { t } = useTranslation();
  return (
  <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
    <Card>
      <CardContent className="p-6">
        <div className="flex items-center space-x-2">
          <Server className="h-4 w-4 text-blue-600" />
          <div>
            <p className="text-xs font-medium text-muted-foreground">{t('terminalMgmt.stats.total')}</p>
            <p className="text-2xl font-bold">{stats.total}</p>
          </div>
        </div>
      </CardContent>
    </Card>
    <Card>
      <CardContent className="p-6">
        <div className="flex items-center space-x-2">
          <CheckCircle className="h-4 w-4 text-green-600" />
          <div>
            <p className="text-xs font-medium text-muted-foreground">{t('terminalMgmt.stats.online')}</p>
            <p className="text-2xl font-bold text-green-600">{stats.online}</p>
            <p className="text-xs text-muted-foreground">
              {stats.total > 0 ? Math.round((stats.online / stats.total) * 100) : 0}%
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
    <Card>
      <CardContent className="p-6">
        <div className="flex items-center space-x-2">
          <XCircle className="h-4 w-4 text-muted-foreground" />
          <div>
            <p className="text-xs font-medium text-muted-foreground">{t('terminalMgmt.stats.offline')}</p>
            <p className="text-2xl font-bold text-muted-foreground">{stats.offline}</p>
            <p className="text-xs text-muted-foreground">
              {stats.total > 0 ? Math.round((stats.offline / stats.total) * 100) : 0}%
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
    <Card>
      <CardContent className="p-6">
        <div className="flex items-center space-x-2">
          <AlertTriangle className="h-4 w-4 text-red-600" />
          <div>
            <p className="text-xs font-medium text-muted-foreground">{t('terminalMgmt.stats.error')}</p>
            <p className="text-2xl font-bold text-red-600">{stats.error}</p>
            <p className="text-xs text-muted-foreground">
              {stats.total > 0 ? Math.round((stats.error / stats.total) * 100) : 0}%
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  </div>
  );
};

export default TerminalStatsCards;
